import React from 'react'
import about from "../assets/img/image4.jpg"
import { BsArrowLeft } from "react-icons/bs"
import "../assets/css/style.css"
import { motion } from 'framer-motion';

const Header = ({ closeModal }) => {
    return (

        <motion.header
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            id="header">
            <i class="bi bi-list  d-xl-none"></i>
            <div className="d-flex flex-column">
            <span 
            className='cross' onClick={() => { closeModal(false) }}><BsArrowLeft  className='cross-icon' /></span>
                <div className="profile"> <img
                    src={about} alt=""
                    className="img-fluid rounded-circle" />
                    <h1 className="text-light">
                        <a href='/'>Saqib Diar</a>
                    </h1>
                    <div className="social-links mt-3 text-center"> 
                    <a href="https://www.youtube.com/@saqiasks" className="youtube" target="_blank"><i className="bx bxl-youtube"></i></a>
                     <a href="https://www.facebook.com/saqibdiar.baRo" className="facebook" target="_blank"><i className="bx bxl-facebook"></i></a> 
                     <a href="https://www.instagram.com/saqib_diar/" className="instagram" target="_blank"><i className="bx bxl-instagram"></i></a> 
                     <a href="https://wa.me/923139189765" className="google-plus" target="_blank"><i className="bx bxl-whatsapp"></i></a> 
                     <a href="https://www.linkedin.com/in/saqib-diar/" className="linkedin" target="_blank"><i className="bx bxl-linkedin"></i></a></div>
                </div>
                <nav id="navbar" className="nav-menu navbar">
                    <ul>
                        <li><a href="#hero" className="nav-link scrollto active" onClick={() => { closeModal(false) }}><i className="bx bx-home"></i>
                            <span>Home</span></a></li>
                        <li><a href="#about" className="nav-link scrollto" onClick={() => { closeModal(false) }}><i className="bx bx-user"></i> <span>About</span></a>
                        </li>
                        <li><a href="#resume" className="nav-link scrollto" onClick={() => { closeModal(false) }}><i className="bx bx-file-blank"></i>
                            <span>Resume</span></a></li>
                        <li><a href="#portfolio" className="nav-link scrollto" onClick={() => { closeModal(false) }}><i className="bx bx-book-content"></i>
                            <span>Portfolio</span></a></li>
                        <li><a href="#services" className="nav-link scrollto" onClick={() => { closeModal(false) }}><i className="bx bx-server"></i>
                            <span>Services</span></a></li>
                        <li><a href="#contact" className="nav-link scrollto" onClick={() => { closeModal(false) }}><i className="bx bx-envelope"></i>
                            <span>Contact</span></a></li>
                    </ul>
                </nav>
            </div>
        </motion.header>
    )
}

export default Header